import { useState, useEffect, useCallback } from 'react';
import TestDetails from '../testDetails';
import PropTypes from 'prop-types';

import Loader from '../loader';
import Cta from '../cta';

const TestCategory = ({ sku, cta }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [hasError, setHasError] = useState(false);
	const [productInfo, setProductInfo] = useState({});
	const customLink = `${cta.link}?cat=${encodeURIComponent(productInfo?.cc_test_category)}&type=${encodeURIComponent(productInfo?.cc_test_mechanism)}/`;

	const fetchData = useCallback(async () => {
		setIsLoading(true);
		try {
			const response = await fetch(
				`${process.env.GATSBY_MAGENTO_PROD_BASE}/rest/V1/covidclinic/products/${sku}`
			);
			const results = await response.json();
			setProductInfo(results);
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
			setHasError(true);
			console.error(error);
		}
	}, [sku]);

	useEffect(() => {
		fetchData();
	}, [sku]);

	if (isLoading) return <Loader isLoading={isLoading} />;

	if (hasError || !productInfo) return null;

	return (
		<div className="section test-category">
			<div className="section__content test-category__content">
				<div className="test-category__image-wrapper">
					<img
						className="test-category__image"
						src={productInfo?.images && productInfo?.images[0].image_url}
						alt={productInfo?.name}
					/>
				</div>
				<div className="test-category__body">
					<p className="typography typography--overline typography--grayscale-60">
						Test Details
					</p>
					<h2 className="typography typography--h2 typography--secondary">
						{productInfo?.name}
					</h2>
					<div className="test-category__badges">
						{productInfo?.cc_product_tags?.split(', ').map((badges, key) => (
							<span
								key={key}
								className="badge badge--pill border--secondary typography typography--secondary typography--body-small test-category__badge-spaced"
							>
								{badges}
							</span>
						))}
					</div>
					<div
						className="typography typography--body"
						dangerouslySetInnerHTML={{
							__html: productInfo?.short_description,
						}}
					/>
					<TestDetails
						className="typography typography--secondary"
						data={{
							categories: productInfo?.cc_test_category || '',
							method: productInfo?.cc_test_mechanism || '',
							cost: `$${productInfo?.price}` || '',
							processingTime: productInfo?.cc_processing_time || '',
						}}
					/>
					<Cta {...cta} customClass="btn btn--secondary" link={customLink}/>
					<div
						className="typography typography--body-small"
						dangerouslySetInnerHTML={{ __html: productInfo?.cta_notes }}
					/>
				</div>
			</div>
		</div>
	);
};

TestCategory.propTypes = {
	sku: PropTypes.string.isRequired,
	cta: PropTypes.oneOfType([
		PropTypes.shape({
			title: PropTypes.string,
			link: PropTypes.string,
		}),
		PropTypes.shape({
			title: PropTypes.string,
			selector: PropTypes.string,
		}),
	]),
};

export default TestCategory;
